<template>
  <div class="d-flex flex-column">
    <template v-if="forecast_comment && forecast_comment.length">
      <p class="font-weight-bold mt-6 px-8" :class="forecast_comment && 'mb-0'">
        Prognos
      </p>
      <p class="text-body-2 px-8 text--secondary">
        {{ forecast_comment }}
      </p>
    </template>
    <div v-else class="mt-6"></div>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'TrafficMessageForecastText',

  computed: {
    forecast_comment: get('trafficMessage/model@forecast_comment')
  }
}
</script>
